/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getData, postData, putData, uploadSingleFile } from "utils/Gateway";
import * as url from "helper/UrlHelper";
import { useTranslation } from "react-i18next";
import downloadFileHandler from "helper/DownloadFile";

const UploadContentModal = ({
  selectedUploadId,
  setSelectedUploadId,
  uploadedFiles = [],
  setuploadedFiles,
  uploadedFileIds = [],
  setuploadedFileIds,
  setShowAlert,
  setMessageType,
  setAlertMessage,
}) => {
  const token = localStorage.getItem("token");
  const { t } = useTranslation();

  const [uploadId, setuploadId] = useState(null);
  const [uploadedFile, setuploadedFile] = useState(null);
  const [uploadedFilePath, setuploadedFilePath] = useState("");
  const [uploadedFileName, setuploadedFileName] = useState("");
  const [title, settitle] = useState("");
  const [details, setdetails] = useState("");
  const [rank, setrank] = useState("");

  const [isSaving, setIsSaving] = useState(false);
  const [errors, setErrors] = useState({});

  //function for validation
  const validateForm = () => {
    const newErrors = {};

    if (!rank.toString().trim()) {
      newErrors.rank = t(
        "Please enter a rank to set the order of this content."
      );
    }

    if (!title.trim()) {
      newErrors.title = t("A title is required for this content.");
    }

    if (!details.trim()) {
      newErrors.details = t(
        "Please provide a short description for this content."
      );
    }

    if (uploadId == null) {
      newErrors.upload = t("Please upload a file for this content.");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const docFileUploadHandler = async (e) => {
    setErrors((prev) => ({
      ...prev,
      upload: "",
    }));

    const file = e.target.files[0];
    try {
      const requestUrl =
        url.API_BASE_URL + url.API_SINGLE_FILE_UPLOAD;
      const response = await uploadSingleFile(requestUrl, file);

      if (response.status) {
        setuploadedFile(response.data);
        setuploadedFilePath(response.data.path);
        setuploadId(response.data._id);
        setuploadedFileName(response.data?.name);
        resetUploadFile();
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  // function for clear file value
  const resetUploadFile = () => {
    const file = document.getElementById("uploadedCourseContentFile");
    if (file) {
      file.value = null;
    }
  };

  const closeDocFileHandler = () => {
    setuploadId(null);
    setuploadedFilePath("");
    setuploadedFile(null);
    resetUploadFile();
  };

  const closeModalHandler = () => {
    setSelectedUploadId(null);
    setuploadId(null);
    setuploadedFilePath("");
    setuploadedFile(null);
    settitle("");
    setdetails("");
    setrank("");
    setErrors({});
  };

  const getContentDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL + url.API_GET_CONTENT_DETAILS + `/${selectedUploadId}`;
      const response = await getData(requestUrl);

      if (response.status) {
        settitle(response.data.title);
        setdetails(response.data.description);
        setrank(response.data.rank);
        setuploadedFile(response.data?.uploadid || null);
        setuploadedFilePath(response.data?.uploadid?.path || "");
        setuploadId(response.data?.uploadid?._id || null);
        setuploadedFileName(response.data?.uploadid?.name || "");
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const saveContentHandler = async () => {
    if (!validateForm()) {
      return;
    }
    try {
      setIsSaving(true);
      let uploadData = {
        title,
        slug: "",
        description: details,
        rank,
        uploadid: uploadId,
      };

      let requestUrl = url.API_BASE_URL;
      let response = {};

      if (selectedUploadId) {
        requestUrl +=
          url.API_UPDATE_CONTENT + `/${selectedUploadId}`;
        response = await putData(requestUrl, uploadData);
      } else {
        requestUrl += url.API_ADD_NEW_CONTENT;
        response = await postData(requestUrl, uploadData);
      }

      setIsSaving(false);

      if (response.status) {
        const fileResponseObj = {
          _id: response.data._id,
          name: response.data?.uploadid?.name,
          title: response.data.title,
          description: response.data.description,
          rank: response.data.rank,
        };

        if (selectedUploadId) {
          const fileIndex = uploadedFiles.findIndex(
            (obj) => obj._id.toString() === fileResponseObj._id.toString()
          );
          if (fileIndex !== -1) {
            setuploadedFiles((prevArr) =>
              prevArr.map((prevObj) =>
                prevObj._id.toString() === fileResponseObj._id.toString()
                  ? { ...prevObj, ...fileResponseObj }
                  : prevObj
              )
            );
          }
        } else {
          setuploadedFiles((prev) => [...prev, fileResponseObj]);
          setuploadedFileIds((prev) => [...prev, response.data._id]);
        }

        setShowAlert(true);
        setMessageType("success");
        setAlertMessage(response.message);

        let bootstrapModal = document.querySelector("#upload_content");
        let modal = bootstrap.Modal.getInstance(bootstrapModal);
        modal.hide();
        closeModalHandler();
      } else {
        setShowAlert(true);
        setMessageType("error");
        setAlertMessage(response.message);
      }
    } catch (error) {
      console.log(error.message);
      setShowAlert(true);
      setMessageType("error");
      setAlertMessage(error.message);
    }
  };

  useEffect(() => {
    if (selectedUploadId) {
      getContentDetails();
    }
  }, [selectedUploadId]);

  return (
    <div
      className="modal fade"
      id="upload_content"
      tabIndex="-1"
      aria-labelledby="uploadContentLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content bg-white border-0 rounded-15">
          <div className="modal-header p-4 border-0">
            <div className="text-center w-100">
              <h3 id="uploadContentLabel" className="mt-0 fs-xl mb-1">
                {selectedUploadId ? t("Edit Content") : t("Add New Content")}
              </h3>
            </div>
            <button
              type="button"
              className="btn-close p-0 bg-gray-200 rounded-circle shadow-none m-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModalHandler}
            ></button>
          </div>
          <div className="modal-body p-4 pt-0">
            <div className="form_wrapper">
              <div className="form-group mb-3">
                <label className="d-block fs-sm fw-semibold mb-2">
                  {t("Rank")} <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  min={1}
                  className={`form-control fs-sm shadow-none ${
                    errors.rank ? "is-invalid" : "border border-gray-300"
                  }`}
                  placeholder={t("e.g., 1 (determines the order)")}
                  value={rank}
                  onChange={(e) => {
                    setrank(e.target.value);
                    if (errors.rank) {
                      setErrors((prev) => ({ ...prev, rank: "" }));
                    }
                  }}
                />
                {errors.rank && (
                  <div className="invalid-feedback d-block">{errors.rank}</div>
                )}
              </div>
              <div className="form-group mb-3">
                <label className="d-block fs-sm fw-semibold mb-2">
                  {t("Title")} <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control fs-sm shadow-none ${
                    errors.title ? "is-invalid" : "border border-gray-300"
                  }`}
                  placeholder={t("e.g., Chapter 1: Introduction")}
                  value={title}
                  onChange={(e) => {
                    settitle(e.target.value);
                    if (errors.title) {
                      setErrors((prev) => ({ ...prev, title: "" }));
                    }
                  }}
                />
                {errors.title && (
                  <div className="invalid-feedback">{errors.title}</div>
                )}
              </div>
              <div className="form-group mb-3">
                <label className="d-block fs-sm fw-semibold mb-2">
                  {t("Details")} <span className="text-danger">*</span>
                </label>
                <textarea
                  cols="30"
                  rows="3"
                  className={`form-control fs-sm shadow-none ${
                    errors.details ? "is-invalid" : "border border-gray-300"
                  }`}
                  placeholder={t(
                    "Provide a brief description of what this content covers."
                  )}
                  value={details}
                  onChange={(e) => {
                    setdetails(e.target.value);
                    if (errors.details) {
                      setErrors((prev) => ({ ...prev, details: "" }));
                    }
                  }}
                ></textarea>
                {errors.details && (
                  <div className="invalid-feedback">{errors.details}</div>
                )}
              </div>

              <div className="form-group upload_content_sec">
                <label className="d-block fs-sm fw-semibold mb-2">
                  {t("Content File")} <span className="text-danger">*</span>
                </label>
                <div className="process_upload mb-3 d-flex align-items-center justify-content-center rounded-10 position-relative">
                  <input
                    type="file"
                    className={`file_btn ${
                      errors.upload ? "is-invalid-file" : ""
                    }`}
                    id="uploadedCourseContentFile"
                    onChange={docFileUploadHandler}
                  />
                  <div className="process_upload_text text-center">
                    <span className="material-symbols-outlined mb-2 d-block text-gray">
                      file_upload
                    </span>
                    <h3 className="text-black fw-semibold fs-md mb-2">
                      {t("Click to Upload")}
                    </h3>
                    <h5 className="fs-xs text-gray mb-0">
                      {t("Max 20mb (PDF, DOC, JPG, MP4)")}
                    </h5>
                  </div>
                </div>

                {errors.upload && (
                  <div className="invalid-feedback d-block">
                    {errors.upload}
                  </div>
                )}
              </div>

              {uploadId && (
                <ul className="uploaded-files d-flex flex-wrap gap-3 p-0 m-0 mt-3">
                  <li className="file d-flex gap-3 align-items-center px-3 py-2 border border-gray rounded-3">
                    <p className="fw-medium m-0">{uploadedFileName}</p>
                    <Link
                      to="#"
                      className="text-primary"
                      onClick={() => downloadFileHandler(uploadedFile)}
                    >
                      <span className="d-block material-symbols-outlined">
                        download
                      </span>
                    </Link>
                    <Link
                      to="#"
                      className="text-danger"
                      onClick={closeDocFileHandler}
                    >
                      <span className="d-block material-symbols-outlined">
                        close
                      </span>
                    </Link>
                  </li>
                </ul>
              )}

              {uploadedFilePath?.split(".").pop() === "mp4" && (
                <video
                  controls
                  width="100%"
                  height={250}
                  src={url.SERVER_URL + uploadedFilePath}
                  className="mt-3 object-fit-cover rounded-3"
                  autoPlay
                >
                  {t("Your browser does not support the video tag.")}
                </video>
              )}
            </div>
            <div className="process_btns_outer d-flex align-items-center justify-content-between mt-4 gap-3">
              <button
                type="button"
                className="btn btn-outline-primary"
                data-bs-dismiss="modal"
                onClick={closeModalHandler}
              >
                {t("Cancel")}
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={saveContentHandler}
                disabled={isSaving}
                style={{
                  cursor: isSaving ? "not-allowed" : "pointer",
                }}
              >
                {t("Save")}
                {isSaving && (
                  <div
                    className="mx-2 spinner-border spinner-border-sm"
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadContentModal;
